export default "__VITE_ASSET__CnYmECyf__"